<template>
  <div class="content">
    <h3>{{ $t('titlePages.listOfWebhookClients') }}</h3>
    <div class="btn-group btn-group-toggle float-right mb-3" data-toggle="buttons">
      <base-button
        @click="AddWebhookShow = true"
        class="btn btn-round btn-just-icon btn-market"
      >{{ $t('buttons.createWebhookClient') }}</base-button>
    </div>
    <card>
      <div class="row">
        <div class="col-xl-1 col-sm-6">
          <base-input>
            <el-select
              class="select-primary pagination-select"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
        <div class="col-xl-8 col-sm-6">
          <label style="margin-top: 10px; font-size: 0.75rem">{{ $t("labels.Datatable.NbrLinePerPage").toUpperCase() }}</label>
        </div>
        <base-input class="col-xl-3 col-sm-6">
          <el-input
            type="search"
            class="mb-3 search-input"
            clearable
            prefix-icon="el-icon-search"
            :placeholder="$t('buttons.BtnSearch2').toUpperCase()"
            v-model="searchQuery"
            aria-controls="datatables"
          >
          </el-input>
        </base-input>
      </div>
      <el-table :data="searchWebhook.slice(from, to)"  row-class-name="booking-table-rows" v-loading="loadingResponse">
        <el-table-column
          prop='societe'
          label="client"
          show-overflow-tooltip
          sortable
          :sort-method="(a, b) => customSortMethod(a, b, 'societe')"
        >
        </el-table-column>
         <el-table-column
          prop='email'
          label="email"
          show-overflow-tooltip
          sortable
          :sort-method="(a, b) => customSortMethod(a, b, 'email')"
        >
        </el-table-column>
        <el-table-column
          prop='etat'
          :label="$t('table.columns.State')"
          show-overflow-tooltip
          sortable
          :width="170"
        >
          <template scope="scope">
            <el-tooltip
              v-if="scope.row.etat === 'valide'"
              :content="$t('labels.pauseTheWebService')"
              effect="light"
              :open-delay="300"
              placement="top"
            >
             <!--  <base-button
                class="btn-link"
                type="success"
                size="sm"
                icon
                disabled
              >
               <i class="fas fa-check icon-large"></i>
              </base-button>-->
            </el-tooltip>
            <el-tooltip
              v-else
              :content="$t('labels.validateTheWebhook')"
              effect="light"
              :open-delay="300"
              placement="top"
            >
            <!--  <base-button
                class="btn-link"
                type="warning"
                size="sm"
                icon
                disabled
              >
                <i class="fas fa-pause"></i>
              </base-button>-->
            </el-tooltip>
             <el-tooltip
                v-if="generatePdfLoading && scope.row.fk_annonceur == index"
                content="LOADING..."
                effect="light"
                :open-delay="300"
                placement="top"
            >
                <base-button
                    class="edit btn-link"
                    type="info"
                    size="sm"
                    icon
                    disabled
                >
                    <i
                        class="el-icon-loading icon-large"
                    ></i>
                </base-button>
            </el-tooltip>
             <el-tooltip
                v-else
                content="Télécharger le document"
                effect="light"
                :open-delay="300"
                placement="top"
                >
                <base-button
                    class="btn-link"
                    type="info"
                    size="sm"
                    @click="generatePdf(scope.row)"
                    icon
                >
                    <i class="fas fa-cloud-download-alt"></i>
                </base-button>
            </el-tooltip>
            <el-tooltip
              content="Envoyer la documentation"
              effect="light"
              :open-delay="300"
              placement="top"
            >
              <base-button
                @click="sendWebhook(scope.row)"
                class="btn-link"
                type="info"
                size="sm"
                :disabled="scope.row.email_notif == 1"
                icon
              >
                <i class="fas fas fa-envelope icon-large"></i>
              </base-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div
        slot="footer"
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div class="">
          <p class="card-category">
            {{ $t('labels.Datatable.Showing') }} {{ from + 1 }}  {{ $t('labels.Datatable.to') }} {{ to }} {{ $t('labels.Datatable.of') }} {{ total }} {{ $t('labels.Datatable.entries') }}
          </p>
        </div>
        <base-pagination
          type="market"
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        >
        </base-pagination>
      </div>
    </card>
    <!-- ADD WEBHOOK MODAL -->
    <modal
      :show.sync="AddWebhookShow"
      footerClasses="justify-content-center"
      body-classes="p-0"
      modalClasses="modal-dialog-centered"
      class="modal-listbase"
    >
      <card class="border-0 mb-0 py-3 fixed-min-height">
        <template slot="header">

          <el-tooltip
            content="Quitter"
            effect="light"
            :open-delay="300"
            placement="top"
          >
            <base-button
              @click.native="closeModal"
              class="btn-link float-right"
              type="danger"
              size="sm"
              icon
            >
              <i class="tim-icons icon-simple-remove"></i>
            </base-button>
          </el-tooltip>

        </template>
        <h3 slot="header" class="modal-title pt-3 text-center">
          {{ $t('labels.addAWebhook') }}
        </h3>

        <div v-if="!errorMessage">
            <div class="col-sm-12">
            <base-input :label="$t('table.columns.Societe')" :error="getError($t('table.columns.Societe'))">
                <el-select class="select-primary"
                :placeholder="$t('table.columns.Societe').toUpperCase()"
                filterable
                v-model="model.client_id"
                :name="$t('table.columns.Societe')"
                v-validate="'required'">
                <el-option
                    v-for="option in SocieteSelects.SocieteList"
                    class="select-primary"
                    :value="option.fk_annonceur"
                    :label="(option.societe.length > 30) ? option.societe.slice(0, 30).toUpperCase() +'...' : option.societe.toUpperCase()"
                    :key="option.id">
                </el-option>
                </el-select>
            </base-input>
            </div>
            <div  class="text-center mt-3">
            <base-button
            v-if="!isLoading"
                type="info"
                @click.native="validate"
                >{{ $t('buttons.BtnAdd').toUpperCase() }}
            </base-button>
            <base-button
                v-else
                    type="info"
                    loading
                    >{{ $t('buttons.BtnAdd').toUpperCase() }}
                </base-button>
            </div>
        </div>
        <div v-else>
            <base-alert type="default">
                <span>
                    <template > {{errorMessage}} </template>
                </span>
                </base-alert>

        </div>

      </card>
    </modal>
    <!-- ADD WEBHOOK modal -->
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option, } from 'element-ui'
import { BasePagination, Modal, BaseAlert } from 'src/components';
import gql from 'graphql-tag'
import Fuse from 'fuse.js';
import { Icons } from "src/pages/Pages/MyMarketAdmin/Product_Icons";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    Modal,
    BaseAlert
  },
  apollo: {
    clients: {
      client: 'MARKET',
      query: gql` query {
        clients {
          fk_annonceur
          societe
        }
      }`,
      result({ data, loader, networkStatus }) {
        this.SocieteSelects.SocieteList = data.clients
      }
    }
  },
  watch: {
    searchQuery(value) {
      let result = this.listWebhook;
      if (value !== '' && this.fuseSearch) {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchWebhook = result;
    }
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchWebhook.length
    }
  },
  data() {
    return {
    index:null,
    generatePdfLoading : false,
    errorMessage :"",
    erreur : "",
    loadingResponse:false,
      api_url:"https://apileadmarket.wee-do-it.net/api",
      isLoading:false,
      model:{
        nom_societe : '',
        client_id : '',
        token : ''
      },
      icons: Icons,
      AddWebhookShow: false,
      searchQuery: null,
      fuseSearch: null,
      searchWebhook: [],
      listWebhook: [],
      SocieteSelects: {
        Societe: '',
        SocieteList: []
      },
      pagination: {
        perPage: 100,
        currentPage: 1,
        perPageOptions: [50, 100, 250, 500],
        total: 0
      },
      options : {
        threshold: 0.2,
        keys: [
          "email",
          "nom",
          "societe",
          "etat",
          "token",
        ]
      },
    }
  },
  mounted(){
    this.getWebhooks()
  },
  methods: {
    customSortMethod(a, b, prop) {
        // Convertir les emails en minuscules pour un tri insensible à la casse
        const valueA = a[prop] ? a[prop].toLowerCase() : '';
        const valueB = b[prop] ? b[prop].toLowerCase() : '';

        // Comparaison
        if (valueA < valueB) return -1;
        if (valueA > valueB) return 1;
        return 0;
    },
    sendWebhook(data){
      this.sendWebhookLoading = true;
      this.index = data.index;
      let accessToken = localStorage.getItem("token_jwt");
      let formData = new FormData()
        formData.append('nom_societe',  data.societe)
        formData.append('client_id',  data.fk_annonceur)
        formData.append('email',  data.email)

        this.axios.post(`${this.api_url}/mail-webhook`, formData, {
            headers: {
                    'authorization': `Bearer ${accessToken}`
                    },
        }).then((response) => {
            if (response.status === 200) {
                const item = this.searchWebhook.find(row => row.fk_annonceur === data.fk_annonceur)
                item.email_notif = 1
                this.closeModal()
                this.$notify({
                    type: "success",
                    verticalAlign: "top",
                    horizontalAlign: "right",
                    message:
                        "Mail envoyé avec succès.",
                });

            }
            else{
                this.$notify({
                    type: "warning",
                    message: "Une erreur est survenue",
                });
            }
        }).catch((error) => {  // Use arrow function to preserve 'this' context
            this.$notify({
                    type: "warning",
                    message: "Une erreur est survenue",
            });
        }).finally(() => {
        // Assurez-vous de toujours réinitialiser l'état de chargement, même en cas d'erreur
            this.sendWebhookLoading = false;
            this.index = null;
        })
    },
    generatePdf(data){
        this.generatePdfLoading = true;
        this.index = data.fk_annonceur
        let accessToken = localStorage.getItem("token_jwt");
        //const filename = `instructions-webhook-${this.model.nom_societe}-${this.formatDate(new Date())}.pdf`
        const filename = `instructions-webhook-${data.societe}-${this.formatDate(new Date())}.pdf`
        let formData = new FormData()
        formData.append('nom_societe',  data.societe)
        formData.append('client_id',  data.fk_annonceur)
        this.axios.post(`${this.api_url}/generate-webhook`, formData, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${accessToken}`
        },
        responseType: "blob" // Pour que la réponse soit un fichier PDF
        }).then((response) => {
        // Lorsque la réponse est reçue, vous pouvez télécharger le PDF
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        }).catch((error) => {
            this.$notify({
                type: "warning",
                message: "Une erreur est survenue",
            });
            console.error("Une erreur est survenue", error);
        }).finally(() => {
        // Assurez-vous de toujours réinitialiser l'état de chargement, même en cas d'erreur
            this.generatePdfLoading = false;
            this.index = null;
        });
    },
    closeModal(){
        this.AddWebhookShow = false
        this.errorMessage = ""
        this.generatePdfLoading = false
        this.index = null
        this.sendWebhookLoading = false;
        this.isLoading = false;
        this.model = {
            nom_societe : '',
            client_id : '',
            token : ''
      }
    },
    getWebhooks(){
      this.loadingResponse = true
      const token = localStorage.getItem("token_jwt")
      this.axios
         .get(`${this.api_url}/webhook-list`,{
            headers: {
              'authorization': `Bearer ${token}`
            }
          })
          .then(response => {
            this.loadingResponse = false
            this.searchWebhook = this.listWebhook = response.data
            this.fuseSearch = new Fuse(this.listWebhook, this.options);
          })
          .catch(error => {
            this.loadingResponse = false
            console.log('error', error)
          });

    },
    formatDate(date) {
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
        this.$validator.validateAll().then((isValid) => {
            if (isValid) {
                this.addWebhookClient();
            }
        });
    },
    addWebhookClient() {
        this.isLoading = true;
        let client = this.SocieteSelects.SocieteList.find(
            societe => societe.fk_annonceur == this.model.client_id
        );

      this.model.nom_societe= client.societe
      let accessToken = localStorage.getItem("token_jwt");
      let formData = new FormData()
      formData.append('nom_societe',  this.model.nom_societe)
      formData.append('client_id',  this.model.client_id)

        this.axios.post(`${this.api_url}/create-webhook`, formData, {
            headers: {
                    'authorization': `Bearer ${accessToken}`
                    },
        }).then((response) => {
            if (response.status === 201) {
                let element = response.data.data
                if(element) {
                    this.searchWebhook.push(element);
                }
                this.closeModal()
                this.$notify({
                    type: "success",
                    verticalAlign: "top",
                    horizontalAlign: "right",
                    message:
                        "Webhook crée avec succès.",
                });

            }
            else{
                this.errorMessage = "Une erreur est survenue."
                this.$notify({
                    type: "warning",
                    message: this.errorMessage,
                });
            }
        }).catch((error) => {  // Use arrow function to preserve 'this' context
            if (error.response && error.response.status === 409) {
                this.errorMessage = "Le webhook existe déjà pour ce client."
            } else {
                this.errorMessage = "Une erreur est survenue."
            }
            this.$notify({
                type: "warning",
                message: this.errorMessage,
            });
            console.error("Une erreur est survenue", error);
        }).finally(() => {
        // Assurez-vous de toujours réinitialiser l'état de chargement, même en cas d'erreur
            this.isLoading = false;
        })

    },
    /* clean(string) {
      string = string.replace(/' '/g, '_');
      string = string.replace(/'-'/g, '_');
      string = string.replace(/[^A-Za-z0-9\-]/g, '');
      return string.toLowerCase();
    },
    clearFiled() {
      this.SocieteSelects.Societe = ''
      this.cons_key = ''
      this.cons_secret = ''
    }, */
  },
}

</script>

<style>
  .booking-table-rows {
    text-transform: uppercase;
  }
  .iconoggodata {
    background: url('/img/oggodata.ico');
    height: 40px;
    width: 40px;
    display: block;
    /* Other styles here */
  }
  .fixed-min-height{
    min-height: 250px;
  }
</style>
